import { render, staticRenderFns } from "./StockFlowQuery.vue?vue&type=template&id=2d8ed00c&scoped=true"
import script from "./StockFlowQuery.vue?vue&type=script&lang=js"
export * from "./StockFlowQuery.vue?vue&type=script&lang=js"
import style0 from "./StockFlowQuery.vue?vue&type=style&index=0&id=2d8ed00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ed00c",
  null
  
)

export default component.exports